import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { useFormik } from "formik";
import formService from "../../services/forms/form.service";
import { HesaplamaAracAnketRequestDto } from "../../services/forms/form.dto";
import { useToast } from "../../utils/toast";
import FormikValueIsValid from "../../utils/FormikValueIsValid";
import ProtokolFirmalarComponent from "../../components/ProtokolFirmalarComponent";
import LoginRequiredModal from "../../components/LoginRequiredModal";
import { useAuth } from "../../utils/auth";
import { useNavigate } from "react-router-dom";

const KarbonAyakIzi = () => {
  const toast = useToast();
  const auth = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const formik = useFormik<HesaplamaAracAnketRequestDto>({
    initialValues: {
      arac_sayisi: 0,
      arac_sayisi_alinan: 0,
      arac_faal_omur: 0,
      arac_pert_miktari: 0
    },
    validate: (values) => {
      const errors: any = {};

      if (values.arac_sayisi < 0) {
        errors.arac_sayisi = "Araç sayısı negatif olamaz.";
      }
      if (values.arac_sayisi_alinan < 0) {
        errors.arac_sayisi_alinan = "Alınan araç sayısı negatif olamaz.";
      }
      if (values.arac_faal_omur < 0) {
        errors.arac_faal_omur = "Araçların faal ömrü negatif olamaz.";
      }
      if (values.arac_pert_miktari < 0) {
        errors.arac_pert_miktari = "Pert olan araç miktarı negatif olamaz.";
      }

      if (values.arac_pert_miktari > values.arac_sayisi) {
        errors.arac_pert_miktari = "Pert olan araç miktarı toplam araç sayısından büyük olamaz.";
      }
      return errors;
    },
    onSubmit: async (values) => {
      // Kullanıcının giriş yapıp yapmadığını kontrol et
      if (!auth.getUser().access_token) {
        setShowLoginModal(true);
        return;
      }

      formService.karbonAyakIziForm(values).then((res) => {
        if (res?.result?.error === null) {
          toast.show("Anket kaydedildi.", "success");
        } else {
          toast.show("Anket kaydedilemedi", "error");
        }
      });
    }
  });

  return (
    <>
      <div className="card">
        <div className="w-full surface-card">
          <div className="text-center mb-4">
            <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">Karbon Ayak İzi Hesaplama</h2>
          </div>
          <p className="text-600 line-height-3 mb-3">
            Araç sayısının en yüksek sayıda tutularak en düşük seviyede yakıt tüketimi için hangi önlemleri almak gerekli?
          </p>
          <div
            className="iframe-container w-full"
            style={{
              margin: "0 auto",
              padding: "0",
              border: "none",
              overflow: "hidden",
              minHeight: "450px"
            }}
          >
            <iframe
              src="/modeller/cor/index2.html"
              title="Karbon Ayak İzi Modeli"
              loading="lazy"
              style={{
                border: "none",
                margin: "0",
                padding: "0",
                width: "100%",
                height: "100%",
                minHeight: "450px"
              }}
              onLoad={(e) => {
                const iframe = e.target as HTMLIFrameElement;
                if (iframe.contentWindow && iframe.contentWindow.document.body) {
                  const body = iframe.contentWindow.document.body;
                  const html = iframe.contentWindow.document.documentElement;
                  const height = Math.max(
                    body.scrollHeight,
                    body.offsetHeight,
                    html.clientHeight,
                    html.scrollHeight,
                    html.offsetHeight
                  );
                  iframe.style.height = `${height}px`;
                }
              }}
            ></iframe>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="w-full surface-card">
          <div className="text-center mb-4">
            <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">Karbon Ayak İzi Anketi</h2>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className="grid">
              <div className="col-12 md:col-8 flex align-items-center">
                <label htmlFor="arac_sayisi" className="text-900 font-medium mb-1">
                  OSB bünyesinde yer alan araç sayısı:
                </label>
              </div>
              <div className="col-12 md:col-4 mb-2">
                <InputNumber
                  inputId="arac_sayisi"
                  value={formik.values.arac_sayisi}
                  className="w-full"
                  inputClassName="w-full"
                  onChange={(e) => {
                    if (!auth.getUser().access_token) {
                      setShowLoginModal(true);
                      return;
                    }
                    formik.setFieldValue("arac_sayisi", e.value);
                  }}
                  showButtons
                  min={0}
                />
                {FormikValueIsValid(formik, "arac_sayisi") && (
                  <small className="p-error block mt-1">{formik.errors.arac_sayisi}</small>
                )}
              </div>

              <div className="col-12 md:col-8 flex align-items-center">
                <label htmlFor="arac_sayisi_alinan" className="text-900 font-medium mb-1">
                  OSB bünyesinde alınan araç sayısı:
                </label>
              </div>
              <div className="col-12 md:col-4 mb-2">
                <InputNumber
                  inputId="arac_sayisi_alinan"
                  value={formik.values.arac_sayisi_alinan}
                  className="w-full"
                  inputClassName="w-full"
                  onChange={(e) => {
                    if (!auth.getUser().access_token) {
                      setShowLoginModal(true);
                      return;
                    }
                    formik.setFieldValue("arac_sayisi_alinan", e.value);
                  }}
                  showButtons
                  min={0}
                />
                {FormikValueIsValid(formik, "arac_sayisi_alinan") && (
                  <small className="p-error block mt-1">{formik.errors.arac_sayisi_alinan}</small>
                )}
              </div>

              <div className="col-12 md:col-8 flex align-items-center">
                <label htmlFor="arac_faal_omur" className="text-900 font-medium mb-1">
                  OSB bünyesindeki araçların faal ömrü:
                </label>
              </div>
              <div className="col-12 md:col-4 mb-2">
                <InputNumber
                  inputId="arac_faal_omur"
                  value={formik.values.arac_faal_omur}
                  className="w-full"
                  inputClassName="w-full"
                  onChange={(e) => {
                    if (!auth.getUser().access_token) {
                      setShowLoginModal(true);
                      return;
                    }
                    formik.setFieldValue("arac_faal_omur", e.value);
                  }}
                  showButtons
                  min={0}
                />
                {FormikValueIsValid(formik, "arac_faal_omur") && (
                  <small className="p-error block mt-1">{formik.errors.arac_faal_omur}</small>
                )}
              </div>

              <div className="col-12 md:col-8 flex align-items-center">
                <label htmlFor="arac_pert_miktari" className="text-900 font-medium mb-1">
                  OSB bünyesinde yıllık pert miktarı:
                </label>
              </div>
              <div className="col-12 md:col-4 mb-2">
                <InputNumber
                  inputId="arac_pert_miktari"
                  value={formik.values.arac_pert_miktari}
                  className="w-full"
                  inputClassName="w-full"
                  onChange={(e) => {
                    if (!auth.getUser().access_token) {
                      setShowLoginModal(true);
                      return;
                    }
                    formik.setFieldValue("arac_pert_miktari", e.value);
                  }}
                  showButtons
                  min={0}
                />
                {FormikValueIsValid(formik, "arac_pert_miktari") && (
                  <small className="p-error block mt-1">{formik.errors.arac_pert_miktari}</small>
                )}
              </div>

              <div className="col-12 mt-3 flex justify-content-end">
                <Button label="Gönder" type="submit" icon="pi pi-check" className="px-5" />
              </div>
            </div>
          </form>
        </div>
        {/* <div className="mb-3 w-full flex justify-content-center">
          <Divider align="center" className="w-9" />
        </div> */}
      </div>

      <ProtokolFirmalarComponent />
      
      {/* Login Required Modal */}
      <LoginRequiredModal 
        visible={showLoginModal} 
        onHide={() => setShowLoginModal(false)} 
      />
    </>
  );
};

export default KarbonAyakIzi;
